import { Flex } from "antd";
import ICON from "../assets/images/coming-soon.svg";
import Footer from "../layouts/web/_components/footer";
import Navbar from "../layouts/web/_components/navbar";
import Platform from "../layouts/web/_components/platform";

type Props = {
  title?: string;
  description?: string;
};

export default function ComingSoon({
  title = "ফিচারটি শীঘ্রই চালু হবে!",
  description = "আপনার চাকরি খোঁজার অভিজ্ঞতা আরও ভালো করতে আমরা নতুন ফিচার নিয়ে আসছি।",
}: Props) {
  return (
    <main>
      <Navbar />
      <Flex
        align="center"
        justify="center"
        className="min-h-[300px] md:min-h-[564px] bg-gradient-to-l from-teal-700 to-gray-800"
      >
        <div>
          <Flex align="center" justify="center">
            <img src={ICON} alt="" />
          </Flex>

          <div className="mt-9 text-white text-center space-y-2.5">
            <h3 className="text-4xl font-bold">{title}</h3>
            <p className="text-base font-medium">{description}</p>
          </div>
        </div>
      </Flex>

      <Platform />
      <Footer isPlatform={true} />
    </main>
  );
}
